import { api as apiProvider } from '@/core/api/';

const baseApiURL = 'api/providers/figureType';
export const getFigureType = async () =>
  apiProvider.get(`${baseApiURL}/search`);
